import config from '../../app/etc/config';

export function getGatewayUrl (client) {
  return config.gateway.url.replace(/%client_code%/g, client.code);
};

export function getConnectionsUrl(client) {
  return `#/connections?displayedFilters={"client_id": true}&filter={"client_id": "${client.id}"}&order=desc&page=1&perPage=50&sort=created_at`;
};
